module.exports = __webpack_public_path__ + "static/media/lozsi.bb298834.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/lozsi.jpg
// module id = 485
// module chunks = 0